export class AbstractPulseTracker {
    static commandMap = new Map([
        ['event', 'event'],
        ['send', 'event'],
        ['set', 'set'],
        ['state', 'set'],
    ]);
}
//# sourceMappingURL=tracker.js.map